module.exports = __webpack_public_path__ + "static/img/BUBLY_SMILE-LEMON-SORB.f2962e6.f2962e6.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mixology/smiles/BUBLY_SMILE-LEMON-SORB.f2962e6.gif
// module id = 7aqu
// module chunks = 0